namespace RioERP.Products {
    export interface ProductsForm {
        ProductName: Serenity.StringEditor;
        Description: Serenity.TextAreaEditor;
        WebsiteUrl: Serenity.StringEditor;
        Thumbnail: Serenity.ImageUploadEditor;
        PackId: Serenity.LookupEditor;
        EProductType: Serenity.EnumEditor;
        SkuCode: Serenity.StringEditor;
        TemplateSerialKeyId: Serenity.IntegerEditor;
        ProductCategList: Serenity.LookupEditor;
        ERioplayVersion: Serenity.EnumEditor;
        RioplayProductCode: Serenity.StringEditor;
        ProductIds: Serenity.StringEditor;
        GrossAmount: Serenity.DecimalEditor;
        DefaultFranchiseeSharePercentage: Serenity.DecimalEditor;
        TeacherName: Serenity.StringEditor;
        DownloadUrl1: Serenity.StringEditor;
        DownloadUrl2: Serenity.StringEditor;
        HasPenDrive: Serenity.BooleanEditor;
        HasBooks: Serenity.BooleanEditor;
        HasCourier: Serenity.BooleanEditor;
        IsLive: Serenity.BooleanEditor;
        InAppDownload: Serenity.BooleanEditor;
        HasVod: Serenity.BooleanEditor;
        ProcesOrderOnPaid: Serenity.BooleanEditor;
        IsCombo: Serenity.BooleanEditor;
        ComboProductId: Serenity.LookupEditor;
        Weight: Serenity.DecimalEditor;
        Height: Serenity.DecimalEditor;
        Width: Serenity.DecimalEditor;
        Length: Serenity.DecimalEditor;
        EPackingType: Serenity.EnumEditor;
        Note: Serenity.StringEditor;
        EShippedby: Serenity.EnumEditor;
        VendorId: Serenity.LookupEditor;
        SupportInfo: Serenity.HtmlContentEditor;
        ProductQueryInfo: Serenity.HtmlContentEditor;
        EOpens: Serenity.EnumEditor;
        EWatchTime: Serenity.EnumEditor;
        EValidityType: Serenity.EnumEditor;
        EValidity: Serenity.EnumEditor;
        ValidTill: Serenity.DateEditor;
        TotalAllowedDuration: Serenity.IntegerEditor;
        EAccessStatus: Serenity.EnumEditor;
        AllowSerialKeyGeneration: Serenity.BooleanEditor;
        ActivateSerialKey: Serenity.BooleanEditor;
        AllowedDevice: Serenity.LookupEditor;
        RioPlayTenantId: Serenity.IntegerEditor;
        Secretkey: Serenity.StringEditor;
        Rioplay8ProductCode: Serenity.StringEditor;
        Rioplay8ESubscriptionType: Serenity.EnumEditor;
        Rioplay8ValidityInDays: Serenity.IntegerEditor;
        Rioplay8ValidDate: Serenity.DateEditor;
        Rioplay8EViewsType: Serenity.EnumEditor;
        Rioplay8ViewsPerContent: Serenity.IntegerEditor;
        Rioplay8EWatchTimetype: Serenity.EnumEditor;
        Rioplay8WatchTime: Serenity.DecimalEditor;
        Rioplay8EDeviceRestrictionType: Serenity.EnumEditor;
        Rioplay8DeviceCount: Serenity.IntegerEditor;
        Rioplay8SwitchCount: Serenity.IntegerEditor;
        Rioplay8TenantId: Serenity.StringEditor;
        Rioplay8AllowedDevice: Serenity.LookupEditor;
        Rioplay8PlaylistIds: Serenity.StringEditor;
    }

    export class ProductsForm extends Serenity.PrefixedContext {
        static formKey = 'Products.Products';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductsForm.init)  {
                ProductsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.TextAreaEditor;
                var w2 = s.ImageUploadEditor;
                var w3 = s.LookupEditor;
                var w4 = s.EnumEditor;
                var w5 = s.IntegerEditor;
                var w6 = s.DecimalEditor;
                var w7 = s.BooleanEditor;
                var w8 = s.HtmlContentEditor;
                var w9 = s.DateEditor;

                Q.initFormType(ProductsForm, [
                    'ProductName', w0,
                    'Description', w1,
                    'WebsiteUrl', w0,
                    'Thumbnail', w2,
                    'PackId', w3,
                    'EProductType', w4,
                    'SkuCode', w0,
                    'TemplateSerialKeyId', w5,
                    'ProductCategList', w3,
                    'ERioplayVersion', w4,
                    'RioplayProductCode', w0,
                    'ProductIds', w0,
                    'GrossAmount', w6,
                    'DefaultFranchiseeSharePercentage', w6,
                    'TeacherName', w0,
                    'DownloadUrl1', w0,
                    'DownloadUrl2', w0,
                    'HasPenDrive', w7,
                    'HasBooks', w7,
                    'HasCourier', w7,
                    'IsLive', w7,
                    'InAppDownload', w7,
                    'HasVod', w7,
                    'ProcesOrderOnPaid', w7,
                    'IsCombo', w7,
                    'ComboProductId', w3,
                    'Weight', w6,
                    'Height', w6,
                    'Width', w6,
                    'Length', w6,
                    'EPackingType', w4,
                    'Note', w0,
                    'EShippedby', w4,
                    'VendorId', w3,
                    'SupportInfo', w8,
                    'ProductQueryInfo', w8,
                    'EOpens', w4,
                    'EWatchTime', w4,
                    'EValidityType', w4,
                    'EValidity', w4,
                    'ValidTill', w9,
                    'TotalAllowedDuration', w5,
                    'EAccessStatus', w4,
                    'AllowSerialKeyGeneration', w7,
                    'ActivateSerialKey', w7,
                    'AllowedDevice', w3,
                    'RioPlayTenantId', w5,
                    'Secretkey', w0,
                    'Rioplay8ProductCode', w0,
                    'Rioplay8ESubscriptionType', w4,
                    'Rioplay8ValidityInDays', w5,
                    'Rioplay8ValidDate', w9,
                    'Rioplay8EViewsType', w4,
                    'Rioplay8ViewsPerContent', w5,
                    'Rioplay8EWatchTimetype', w4,
                    'Rioplay8WatchTime', w6,
                    'Rioplay8EDeviceRestrictionType', w4,
                    'Rioplay8DeviceCount', w5,
                    'Rioplay8SwitchCount', w5,
                    'Rioplay8TenantId', w0,
                    'Rioplay8AllowedDevice', w3,
                    'Rioplay8PlaylistIds', w0
                ]);
            }
        }
    }
}
